export const RequestStatus = {
  LOADING: 'loading',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  Status: 'idle',
  Active: "Active",
  Inactive: "Inactive"
} as const;

